// ABOUTME: class-variance-authority variants of CLabel
// ABOUTME: Kept apart from the component so CLabel.tsx exports only the component

import { cva } from "class-variance-authority"

export const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
)
